import React from "react";
import { Spinner } from "reactstrap";
import { Pagination } from "components/Pagination";
import { PublicJobCard } from "./PublicJobCard";
import { MappedJob } from "../../store/services/jobApi";

interface JobListProps {
    jobs: MappedJob[];
    isLoading?: boolean;
    error?: any;
    totalCount?: number;
    itemsPerPage?: number;
    currentPage?: number;
    onPageChange?: (page: number) => void;
    emptyMessage?: string;
    showPagination?: boolean;
}

export const JobList = ({
    jobs,
    isLoading = false,
    error,
    totalCount = 0,
    itemsPerPage = 12,
    currentPage = 1,
    onPageChange,
    emptyMessage = "No jobs match your search",
    showPagination = true
}: JobListProps) => {
    const totalPages = Math.ceil(totalCount / itemsPerPage);

    if (isLoading) {
        return (
            <div className="oec-section-inner oec-jobs-status">
                <Spinner color="primary" />
                <p>Loading available positions...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="oec-section-inner oec-jobs-status">
                <p>Error loading jobs. Please try again later.</p>
            </div>
        );
    }

    return (
        <div className="oec-section-inner">
            <div className="oec-jobs-results">
                <h2>{totalCount} {totalCount === 1 ? "Job" : "Jobs"} Found</h2>
                {totalCount > itemsPerPage && (
                    <span>Page {currentPage} of {totalPages}</span>
                )}
            </div>

            {jobs.length > 0 ? (
                <div className="oec-card-grid oec-card-grid-3">
                    {jobs.map((job: MappedJob) => (
                        <PublicJobCard key={job.id} job={job} />
                    ))}
                </div>
            ) : (
                <div className="oec-jobs-status">
                    <h3>{emptyMessage}</h3>
                    <p>Try a different keyword.</p>
                </div>
            )}

            {showPagination && onPageChange && totalPages > 1 && (
                <div className="d-flex justify-content-center mt-4">
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={onPageChange}
                    />
                </div>
            )}
        </div>
    );
};
